<div class="w-100 rubik_global">
    <div class="container-fluid d-block d-sm-none">
      <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12 d-grid  py-5 px-5 mt-5">
                <div class="fw-bold fs-1  text-center">
                  <span class="">
                    Domina el inglés 
                  </span>
                </div>
                <div class="fw-bold fs-6 text-center">
                  <span class="">
                    <br><br>
                    A tu ritmo desde cualquier lugar.
                  </span>
                </div>
                <div class="px-auto">
                  <hr class="col-6 rounded mx-auto" style="background-color: #50E170; border: 0.5px solid #50E170; opacity: 5;">
                </div>
                <div class=" fs-6 text-center">
                  <span class=" ">
                    Wediom es una plataforma innovadora que Impulsa a los estudiantes a aprender inglés de una forma 
                    diversidad y simple a través de la cultura estadounidense.
                  </span>
                </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 d-grid justify-content-start p-4 gap-2 mb-5">
            <img  class="rounded-4" src="assets/img/sec_1.png"   style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
            
            <button mat-raised-button class="align-self-center mx-2" (click)="formulario_2()" style="background-color: #1CA33A; color: #fff;">QUIERO REGISTRARME AL WEBINAR</button>
            
        </div>
      </div>
      <!-- <div class="row seccion_light">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid gap-2 p-5">
                <div class="fw-bold fs-2 d-flex justify-content-center mb-3 ">
                  <span class="text-center">
                    Paso a paso de Wediom
                  </span>
                </div>
                <div class="d-flex justify-content-center mb-3">
                  <hr class="col-3 rounded" style="background-color: #062959; border: 0.5px solid #062959; opacity: 5;">
                </div>
                <div class="d-grid justify-content-center mb-3 gap-3">
                  <div class="rounded-4 seccion_light_3 d-grid p-3 mx-2 gap-4 w-100">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-primary" style="margin: 5% 30%; padding: 15% 0%;">
                        1
                      </span>
                      <span class="fw-bold fs-3 text-center text-black">
                        Pilares
                      </span>
                      <span class="text-black text-center" style="font-size: 12px;">
                        Descubre cómo estudiar y comprender las bases 
                        fundamentales de un idioma acelera tu aprendizaje.
                      </span>
                  </div>
                  <div class="rounded-4 seccion_light_3 d-grid p-3 mx-2 gap-4 w-100">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-danger" style="margin: 5% 30%; padding: 15% 0%;">
                        2
                      </span>
                      <span class="fw-bold fs-3 text-center text-black">
                        Pilares
                      </span>
                      <span class="text-black text-center" style="font-size: 12px;">
                        Descubre cómo estudiar y comprender las bases 
                        fundamentales de un idioma acelera tu aprendizaje.
                      </span>
                  </div>
                  <div class="rounded-4 seccion_light_3 d-grid p-3 mx-2 gap-4 w-100">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-primary" style="margin: 5% 30%; padding: 15% 0%;">
                        3
                      </span>
                      <span class="fw-bold fs-3 text-center text-black">
                        Pilares
                      </span>
                      <span class="text-black text-center" style="font-size: 12px;">
                        Descubre cómo estudiar y comprender las bases 
                        fundamentales de un idioma acelera tu aprendizaje.
                      </span>
                  </div>
                </div>
        </div>
      </div> -->
      <div class="row seccion_light_2">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid justify-content-start py-3 px-5">
          <div class="fw-bold fs-2 d-flex justify-content-center mt-5 mb-3 ">
            <span class="text-center">
              Pilares del Idioma Inglés
            </span>
          </div>
          <div class=" mb-3 d-flex justify-content-center">
            <hr class="col-6 rounded align-self-center mx-5" style="background-color: #062959; border: 0.5px solid #062959; opacity: 5;">
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center p-4">
          <img  src="assets/img/sec_2.png" class="rounded-4 mx-2"    style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12">
                <div class=" mb-3 d-flex justify-content-center px-4 mb-3 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #FF004F;">
                      <div class="px-3">
                        <img src="assets/img/sec_3.png" width="80px">
                      </div>
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #FF004F;">
                          Listening
                        </span>
                        <span class="text-left">
                          Escuchar es fundamental. Comprender el idioma hablado es la base para hablar con fluidez.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-3 d-flex justify-content-center px-4 mb-3 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #116EEE;">
                      <div class="px-3">
                        <img src="assets/img/sec_4.png" width="80px">
                      </div>
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #116EEE;">
                          Speaking
                        </span>
                        <span class="text-left">
                          Hablar es la aplicación práctica del idioma. Practicar la pronunciación y la fluidez es esencial. 
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-3 d-flex justify-content-center px-4 mb-3 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #FF004F;">
                      <div class="px-3">
                        <img src="assets/img/sec_5.png" width="80px">
                      </div>
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #FF004F;">
                          Reading
                        </span>
                        <span class="text-left">
                          Leer expande el vocabulario y la comprensión gramatical. Descifrar textos escritos es una habilidad importante.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-3 d-flex justify-content-center px-4 mb-3 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #116EEE;">
                      <div class="px-3">
                        <img src="assets/img/sec_6.png" width="80px">
                      </div>
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #116EEE;">
                          Writing
                        </span>
                        <span class="text-left">
                          Escribir permite expresar ideas de forma clara y precisa. Practicar la gramática y la ortografía es crucial.
                        </span>
                      </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center px-4 mb-5">
                  <button mat-raised-button class="align-self-center w-100" (click)="formulario_2()" style="background-color: #1CA33A; color: #fff;">QUIERO REGISTRARME AL WEBINAR</button>
                </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12 p-5">
                <div class="fw-bold fs-4 d-flex justify-content-center mt-3 mb-5">
                  <span class="text-center">
                    Tiempos Verbales en Inglés
                  </span>
                </div>
                <div class=" fs-6 d-flex justify-content-center mb-3">
                      <div class="vr mx-2" style="background-color: #FF4D84; border: 0.5px solid #FF4D84; opacity: 5;"></div>
                      <span class="mr-3">Presente Simple</span> 
                      <div class="vr mx-2" style="background-color: #5899F3; border: 0.5px solid #5899F3; opacity: 5;"></div>
                      <span class="mr-3">Pasado Simple</span> 
                      <div class="vr mx-2" style="background-color: #73E78D; border: 0.5px solid #73E78D; opacity: 5;"></div>
                      <span class="mr-3">Futuro Simple</span> 
                      <div class="vr mx-2" style="background-color: #FFA30E; border: 0.5px solid #FFA30E; opacity: 5;"></div>
                      <span class="mr-3">Presente Continuo</span> 
                </div>
                <div class=" fs-6 d-flex justify-content-center mb-3">
                      <div class="vr mx-2" style="background-color: #FF4D84; border: 0.5px solid #FF4D84; opacity: 5;"></div>
                      <span class="mr-3">Pasado Continuo</span> 
                      <div class="vr mx-2" style="background-color: #88B6F7; border: 0.5px solid #88B6F7; opacity: 5;"></div>
                      <span class="mr-3">Futuro Continuo</span> 
                      <div class="vr mx-2" style="background-color: #FF4D84; border: 0.5px solid #FF4D84; opacity: 5;"></div>
                      <span class="mr-3">Presente Perfecto</span> 
                      <div class="vr mx-2" style="background-color: #73E78D; border: 0.5px solid #73E78D; opacity: 5;"></div>
                      <span class="mr-3">Pasado Perfecto</span> 
                </div>
                <div class=" fs-6 d-flex justify-content-center mb-5">
                      <div class="vr mx-2" style="background-color: #5899F3; border: 0.5px solid #5899F3; opacity: 5;"></div>
                      <span class="mr-3">Futuro Perfecto</span> 
                      <div class="vr mx-2" style="background-color: #FF4D84; border: 0.5px solid #FF4D84; opacity: 5;"></div>
                      <span class="mr-3">Presente Perfecto Continuo</span> 
                      <div class="vr mx-2" style="background-color: #FFA30E; border: 0.5px solid #FFA30E; opacity: 5;"></div>
                      <span class="mr-3">Pasado Perfecto Continuo</span> 
                      <div class="vr mx-2" style="background-color: #73E78D; border: 0.5px solid #73E78D; opacity: 5;"></div>
                      <span class="mr-3">Futuro Perfecto Continuo</span> 
                </div>
        </div>
      </div>
      <div class="row seccion_light_2">
        <div class="col-md-12 mt-5">
          <div class="fw-bold fs-2 d-flex justify-content-center mt-5 mb-3">
            <span class="text-center">
              Cómo la metodología paso a 
              <br>
              <br>
              paso de Wediom facilita el
              <br>
              <br>
              aprendizaje efectivo del inglés
            </span>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center p-4">
          <img  src="assets/img/sec_7.png" class="rounded-4"   style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 p-2">
                <div class=" mb-2 d-flex justify-content-center px-3 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #FF004F;">
                      <div class="d-grid gap-2">
                        <span class="text-center fs-3 fw-bold" style="color: #FF004F;">
                          Currículo integral
                        </span>
                        <span class="text-center">
                          El enfoque paso a paso de Wediom garantiza que los estudiantes desarrollen una comprensión integral del idioma inglés.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-2 d-flex justify-content-center px-3 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #116EEE;">
                      <div class="d-grid gap-2">
                        <span class="text-center fs-3 fw-bold" style="color: #116EEE;">
                          Experiencias atractivas
                        </span>
                        <span class="text-center">
                          Las lecciones interactivas, los escenarios del mundo real y la retroalimentación 
                          personalizada mantienen a los estudiantes motivados y activamente involucrados en el proceso de aprendizaje.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-2 d-flex justify-content-center px-3 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #FF004F;">
                      <div class="d-grid gap-2">
                        <span class="text-center fs-3 fw-bold" style="color: #FF004F;">
                          Progreso mensurable
                        </span>
                        <span class="text-center">
                          Las evaluaciones periódicas y los análisis basados en datos permiten a los estudiantes 
                          hacer un seguimiento de su progreso y alcanzar sus objetivos de aprendizaje del idioma.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-2 d-flex justify-content-center px-3 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #116EEE;">
                      <div class="d-grid gap-2">
                        <span class="text-center fs-3 fw-bold" style="color: #116EEE;">
                          Entorno de apoyo
                        </span>
                        <span class="text-center">
                          Wediom brinda un entorno acogedor e inclusivo donde los estudiantes se
                           sienten empoderados para asumir riesgos y mejorar continuamente.
                        </span>
                      </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center px-3 mb-5">
                  <button mat-raised-button class="align-self-center w-100" (click)="formulario_2()"  style="background-color: #1CA33A; color: #fff;">QUIERO REGISTRARME AL WEBINAR</button>
                </div>
        </div>
      </div>
      <div class="row seccion_light">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid gap-2" style="padding: 5%;">
                <div class="fw-bold fs-2 d-flex justify-content-center mb-3 ">
                  <span class="text-center">
                    El Enfoque Estructurado
                  </span>
                </div>
                <div class=" fs-6 d-flex justify-content-center mb-3 ">
                  <span class="text-center">
                    Metodología paso apaso de Wediom
                  </span>
                </div>
                <div class="d-flex justify-content-center mb-3 gap-3">
                  <div class="rounded-4 seccion_light_4 d-grid p-3 mx-2 gap-4 w-100 p-3">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-white" style="margin: 9% 40%; padding: 7% 0%;color: #0B4595;">
                        1
                      </span>
                      <span class="fw-bold fs-3 text-center mb-1">
                        Construcción de la base
                      </span>
                      <span class=" text-center" style="font-size: 12px;">
                        Establecer un dominio sólido de la gramática, el vocabulario y 
                        la pronunciación del inglés como base de la competencia lingüística.
                      </span>
                  </div>
                </div>
                <div class="d-flex justify-content-center mb-3 gap-3">
                  <div class="rounded-4 seccion_light_4 d-grid p-3 mx-2 gap-4 w-100 p-3">
                    <span class="fw-bold fs-1 text-center rounded-circle bg-white" style="margin: 9% 40%; padding: 7% 0%;color: #0B4595;">
                      2
                    </span>
                    <span class="fw-bold fs-3 text-center mb-1">
                      Desarrollo de habilidades
                    </span>
                    <span class="text-center" style="font-size: 12px;">
                      Cultivar habilidades prácticas de comunicación en escucha, 
                      habla, lectura y escritura a través de ejercicios específicos.
                    </span>
                </div>
                </div>
                <div class="d-flex justify-content-center mb-5 gap-3">
                  <div class="rounded-4 seccion_light_4 d-grid p-3 mx-2 gap-4 w-100 p-3">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-white" style="margin: 9% 40%; padding: 7% 0%; color: #0B4595;">
                        3
                      </span>
                      <span class="fw-bold fs-3 text-center">
                        Aplicación en el mundo real
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        Establecer un dominio sólido de la gramática, el vocabulario y la pronunciación del inglés como base de la competencia lingüística.
                      </span>
                  </div>
                </div>
        </div>
      </div>
      <!-- <div class="row seccion_light_2">
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center p-4">
          <div class="fw-bold fs-2 d-flex justify-content-center mb-4 ">
            <span class="text-center">
              Aprende inglés y Cultura
            </span>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center p-4">
          <img  src="assets/img/sec_8.png" class="rounded-4"   style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid gap-2" >
                <div class="d-grid justify-content-center mt-4 mb-3 gap-3 px-2">
                  <div class="d-grid">
                    <div class="fw-bold fs-2 d-flex justify-content-center mb-2 ">
                      <span class="text-center mb-3" style="color: #116EEE;">
                        Enfoque de
                        <br>
                        <br>
                        inmersión
                      </span>
                    </div>
                    <div class="fs-5 d-flex justify-content-center mb-4 ">
                      <span class="text-center">
                        El plan de estudios de Wediom te sumerge en elementos auténticos de la cultura estadounidense, 
                        lo que te ayuda a desarrollar habilidades lingüísticas en un contexto del mundo real.
                      </span>
                    </div>
                  </div>
                  <div class="d-grid">
                    <div class="fw-bold fs-2 d-flex justify-content-center mb-2 ">
                      <span class="text-center mb-3" style="color: #FF004F;">
                        Aprendizaje 
                        <br>
                        <br>
                        estructurado
                      </span>
                    </div>
                    <div class="fs-5 d-flex justify-content-center mb-4 ">
                      <span class="text-center">
                        El plan de estudios de Wediom te sumerge en elementos auténticos de la cultura estadounidense, 
                        lo que te ayuda a desarrollar habilidades lingüísticas en un contexto del mundo real.
                      </span>
                    </div>
                  </div>
                  <div class="d-grid">
                    <div class="fw-bold fs-2 d-flex justify-content-center mb-2 ">
                      <span class="text-center mb-3" style="color: #116EEE;">
                        Orientación 
                        <br>
                        <br>
                        personalizada
                      </span>
                    </div>
                    <div class="fs-5 d-flex justify-content-center mb-4 ">
                      <span class="text-center">
                        El plan de estudios de Wediom te sumerge en elementos auténticos de la cultura estadounidense, 
                        lo que te ayuda a desarrollar habilidades lingüísticas en un contexto del mundo real.
                      </span>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center px-2">
                  <button mat-raised-button class="align-self-center w-100" (click)="formulario_2()" style="background-color: #1CA33A; color: #fff;">QUIERO REGISTRARME AL WEBINAR</button>
                </div>
        </div>
      </div> -->
      <div class="row seccion_light">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid gap-2 p-4">
                <div class="fw-bold fs-3 d-flex justify-content-center mb-5 ">
                  <span class="text-center" >
                    Aprendizaje Progresivo y Estructurado
                  </span>
                </div>
                <div class="d-grid justify-content-center mb-3 gap-3 mx-2">
                  <div class="rounded-4  d-grid  w-100" style=" border: 1.5px solid #116EEE; opacity: 5;">
                      <img class="rounded-4" src="../../../../assets/img/sec_9.png" style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
                  </div>
                  <div class="rounded-4 d-grid  w-100 p-4 bg-white" style=" border: 1.5px solid #116EEE; opacity: 5;">
                      <span class="fw-bold fs-3 text-center mb-1" style="color: #116EEE;">
                        Estructura o Columna vertebral
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        El plan de estudios de Wediom está diseñado con pasos incrementales para consolidar 
                        su dominio de la gramática, el vocabulario y las habilidades de comunicación en inglés.
                      </span>
                  </div>
                </div>
                <div class="d-grid justify-content-center mb-3 gap-3 mx-2">
                  <div class="rounded-4  d-grid  w-100" style=" border: 1.5px solid #FFB207; opacity: 5;">
                    <img class="rounded-4" src="../../../../assets/img/sec_10.png" style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
                  </div>
                  <div class="rounded-4 d-grid  w-100 p-4 bg-white" style=" border: 1.5px solid #FFB207; opacity: 5;">
                      <span class="fw-bold fs-3 text-center mb-1" style="color: #FFB207;">
                        Estructura o Columna vertebral
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        El plan de estudios de Wediom está diseñado con pasos incrementales para consolidar 
                        su dominio de la gramática, el vocabulario y las habilidades de comunicación en inglés.
                      </span>
                  </div>
                </div>
                <div class="d-grid justify-content-center mb-3 gap-3 mx-2">
                  <div class="rounded-4  d-grid  w-100" style=" border: 1.5px solid #116EEE; opacity: 5;">
                    <img class="rounded-4" src="../../../../assets/img/sec_11.png" style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
                  </div>
                  <div class="rounded-4 d-grid  w-100 p-4 bg-white" style=" border: 1.5px solid #116EEE; opacity: 5;">
                      <span class="fw-bold fs-3 text-center mb-1" style="color: #116EEE;">
                        Mejora Continua
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        Las evaluaciones regulares y la retroalimentación personalizada aseguran que
                         esté haciendo un progreso constante y logrando sus objetivos de aprendizaje de idiomas.
                      </span>
                  </div>
                </div>
        </div>
      </div>
      <!-- final -->
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid  py-5 px-3 mt-5">
                <div class="fw-bold fs-2  text-center mb-3">
                  <span class="">
                    ¡Reserva tu lugar ahora!
                  </span>
                </div>
                <div class="px-auto">
                  <hr class="col-4 rounded mx-auto" style="background-color: #50E170; border: 0.5px solid #50E170; opacity: 5;">
                </div>
                <div class=" fs-5 text-center">
                  <span class=" ">
                    Completa el formulario y Aprende estrategias clave y 
                    recibe consejos de expertos del Idioma Inglés en nuestro webinar exclusivo para ti.
                  </span>
                </div>
                <div class="d-flex justify-content-center mt-5">
                    <div class="col-12 mat-elevation-z8 p-3 rounded" style="background-color: #FFFFFF;">
                        <form id="forma_2" [formGroup]="forma" (ngSubmit)="modalrespuesta()" >
                            <div class="row pb-2">
                                <div class="col-12 d-flex justify-content-center">
                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                        <mat-label>Nombre y Apellido </mat-label>
                                        <input type="text" matInput    autocomplete="off" formControlName="des_usuario" style="color: #000;">
                                        <span mat-icon-button matSuffix >
                                            <mat-icon >account_circle</mat-icon>
                                         </span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row pb-2">
                                <div class="col-12 d-flex justify-content-center">
                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                        <mat-label>Teléfono</mat-label>
                                        <input type="text" matInput    autocomplete="off" formControlName="tel_usuario" style="color: #000;">
                                        <span mat-icon-button matSuffix >
                                            <mat-icon >account_circle</mat-icon>
                                         </span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row pb-2">
                                <div class="col-12 d-flex justify-content-center">
                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                        <mat-label>Correo Electrónico</mat-label>
                                        <input type="text" matInput    autocomplete="off" formControlName="mail_usuario" style="color: #000;">
                                        <span mat-icon-button matSuffix >
                                            <mat-icon >account_circle</mat-icon>
                                         </span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row pb-2">
                                <div class="col-12 d-flex justify-content-center">
                                    <button class="col-12 mb-2" mat-raised-button type="submit"  [disabled]="forma.invalid" style="background-color: #1CA33A; color: #fff;"> ENVIAR</button>
                                </div>  
                            </div>
                        </form>
                    </div>
                </div>
        </div>
      </div>
    </div>
    <div class="container d-none d-sm-block ">
      <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12 d-grid  py-5 px-5 mt-5">
                <div class="fw-bold fs-1  text-center">
                  <span class="">
                    Domina el inglés 
                  </span>
                </div>
                <div class="fw-bold fs-3 text-center">
                  <span class="">
                    A tu ritmo desde cualquier lugar.
                  </span>
                </div>
                <div class="px-auto">
                  <hr class="col-4 rounded mx-auto" style="background-color: #50E170; border: 0.5px solid #50E170; opacity: 5;">
                </div>
                <div class=" fs-5 text-center">
                  <span class=" ">
                    Wediom es una plataforma innovadora que Impulsa a los estudiantes a aprender inglés de una forma 
                    diversidad y simple a través de la cultura estadounidense.
                  </span>
                </div>
                <div class="d-grid">
                  <button mat-raised-button class="align-self-center mx-5" (click)="formulario()" style="background-color: #1CA33A; color: #fff;">QUIERO REGISTRARME AL WEBINAR</button>
                </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-start p-0">
            <img  src="assets/img/sec_1.png"   style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
        </div>
      </div>
      <!-- <div class="row seccion_light">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid gap-2" style="padding: 5%;">
                <div class="fw-bold fs-2 d-flex justify-content-center mb-3 ">
                  <span class="text-center">
                    Paso a paso de Wediom
                  </span>
                </div>
                <div class="d-flex justify-content-center mb-3">
                  <hr class="col-3 rounded" style="background-color: #062959; border: 0.5px solid #062959; opacity: 5;">
                </div>
                <div class="d-flex justify-content-center mb-3 gap-3">
                  <div class="rounded-4 seccion_light_3 d-grid p-3 mx-2 gap-4 w-25">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-primary" style="margin: 5% 30%; padding: 15% 0%;">
                        1
                      </span>
                      <span class="fw-bold fs-3 text-center text-black">
                        Pilares
                      </span>
                      <span class="text-black text-center" style="font-size: 12px;">
                        Descubre cómo estudiar y comprender las bases 
                        fundamentales de un idioma acelera tu aprendizaje.
                      </span>
                  </div>
                  <div class="rounded-4 seccion_light_3 d-grid p-3 mx-2 gap-4 w-25">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-danger" style="margin: 5% 30%; padding: 15% 0%;">
                        2
                      </span>
                      <span class="fw-bold fs-3 text-center text-black">
                        Pilares
                      </span>
                      <span class="text-black text-center" style="font-size: 12px;">
                        Descubre cómo estudiar y comprender las bases 
                        fundamentales de un idioma acelera tu aprendizaje.
                      </span>
                  </div>
                  <div class="rounded-4 seccion_light_3 d-grid p-3 mx-2 gap-4 w-25">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-primary" style="margin: 5% 30%; padding: 15% 0%;">
                        3
                      </span>
                      <span class="fw-bold fs-3 text-center text-black">
                        Pilares
                      </span>
                      <span class="text-black text-center" style="font-size: 12px;">
                        Descubre cómo estudiar y comprender las bases 
                        fundamentales de un idioma acelera tu aprendizaje.
                      </span>
                  </div>
                </div>
        </div>
      </div> -->
      <div class="row seccion_light_2">
        <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-start p-5">
          <img  src="assets/img/sec_2.png" class="rounded-4 mx-5" height="750px"   style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
                <div class="fw-bold fs-2 d-flex justify-content-center mt-5 mb-3">
                  <span class="text-center">
                    Pilares del Idioma Inglés
                  </span>
                </div>
                <div class=" mb-3 d-flex justify-content-center">
                  <hr class="col-4 rounded align-self-center mx-5" style="background-color: #062959; border: 0.5px solid #062959; opacity: 5;">
                </div>
                <div class=" mb-3 d-flex justify-content-center px-5 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #FF004F;">
                      <div class="px-3">
                        <img src="assets/img/sec_3.png" width="80px">
                      </div>
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #FF004F;">
                          Listening
                        </span>
                        <span class="text-left">
                          Escuchar es fundamental. Comprender el idioma hablado es la base para hablar con fluidez.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-3 d-flex justify-content-center px-5 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #116EEE;">
                      <div class="px-3">
                        <img src="assets/img/sec_4.png" width="80px">
                      </div>
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #116EEE;">
                          Speaking
                        </span>
                        <span class="text-left">
                          Hablar es la aplicación práctica del idioma. Practicar la pronunciación y la fluidez es esencial. 
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-3 d-flex justify-content-center px-5 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #FF004F;">
                      <div class="px-3">
                        <img src="assets/img/sec_5.png" width="80px">
                      </div>
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #FF004F;">
                          Reading
                        </span>
                        <span class="text-left">
                          Leer expande el vocabulario y la comprensión gramatical. Descifrar textos escritos es una habilidad importante.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-3 d-flex justify-content-center px-5 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #116EEE;">
                      <div class="px-3">
                        <img src="assets/img/sec_6.png" width="80px">
                      </div>
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #116EEE;">
                          Writing
                        </span>
                        <span class="text-left">
                          Escribir permite expresar ideas de forma clara y precisa. Practicar la gramática y la ortografía es crucial.
                        </span>
                      </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center px-5">
                  <button mat-raised-button class="align-self-center w-100" (click)="formulario()" style="background-color: #1CA33A; color: #fff;">QUIERO REGISTRARME AL WEBINAR</button>
                </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12 p-5">
                <div class="fw-bold fs-2 d-flex justify-content-center mt-5 mb-5">
                  <span class="text-center">
                    Tiempos Verbales en Inglés
                  </span>
                </div>
                <div class=" fs-6 d-flex justify-content-center mb-3">
                      <div class="vr mx-2" style="background-color: #FF4D84; border: 0.5px solid #FF4D84; opacity: 5;"></div>
                      <span class="mr-3">Presente Simple</span> 
                      <div class="vr mx-2" style="background-color: #5899F3; border: 0.5px solid #5899F3; opacity: 5;"></div>
                      <span class="mr-3">Pasado Simple</span> 
                      <div class="vr mx-2" style="background-color: #73E78D; border: 0.5px solid #73E78D; opacity: 5;"></div>
                      <span class="mr-3">Futuro Simple</span> 
                      <div class="vr mx-2" style="background-color: #FFA30E; border: 0.5px solid #FFA30E; opacity: 5;"></div>
                      <span class="mr-3">Presente Continuo</span> 
                      <div class="vr mx-2" style="background-color: #FF4D84; border: 0.5px solid #FF4D84; opacity: 5;"></div>
                      <span class="mr-3">Pasado Continuo</span> 
                      <div class="vr mx-2" style="background-color: #88B6F7; border: 0.5px solid #88B6F7; opacity: 5;"></div>
                      <span class="mr-3">Futuro Continuo</span> 
                      <div class="vr mx-2" style="background-color: #FF4D84; border: 0.5px solid #FF4D84; opacity: 5;"></div>
                      <span class="mr-3">Presente Perfecto</span> 
                </div>
                <div class=" fs-6 d-flex justify-content-center mb-5">
                      <div class="vr mx-2" style="background-color: #73E78D; border: 0.5px solid #73E78D; opacity: 5;"></div>
                      <span class="mr-3">Pasado Perfecto</span> 
                      <div class="vr mx-2" style="background-color: #5899F3; border: 0.5px solid #5899F3; opacity: 5;"></div>
                      <span class="mr-3">Futuro Perfecto</span> 
                      <div class="vr mx-2" style="background-color: #FF4D84; border: 0.5px solid #FF4D84; opacity: 5;"></div>
                      <span class="mr-3">Presente Perfecto Continuo</span> 
                      <div class="vr mx-2" style="background-color: #FFA30E; border: 0.5px solid #FFA30E; opacity: 5;"></div>
                      <span class="mr-3">Pasado Perfecto Continuo</span> 
                      <div class="vr mx-2" style="background-color: #73E78D; border: 0.5px solid #73E78D; opacity: 5;"></div>
                      <span class="mr-3">Futuro Perfecto Continuo</span> 
                      <div class="vr mx-2" style="background-color: #88B6F7; border: 0.5px solid #88B6F7; opacity: 5;"></div>
                </div>
        </div>
      </div>
      <div class="row seccion_light_2">
        <div class="col-md-12 mt-5">
          <div class="fw-bold fs-2 d-flex justify-content-center mt-5 mb-3">
            <span class="text-center">
              Cómo la metodología paso a paso de Wediom facilita el
              <br>
              <br>
              aprendizaje efectivo del inglés
            </span>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 p-5">
                <div class=" mb-5 d-flex justify-content-center px-5 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #FF004F;">
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #FF004F;">
                          Currículo integral
                        </span>
                        <span class="text-left">
                          El enfoque paso a paso de Wediom garantiza que los estudiantes desarrollen una comprensión integral del idioma inglés.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-5 d-flex justify-content-center px-5 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #116EEE;">
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #116EEE;">
                          Experiencias atractivas
                        </span>
                        <span class="text-left">
                          Las lecciones interactivas, los escenarios del mundo real y la retroalimentación personalizada
                           mantienen a los estudiantes motivados y activamente involucrados en el proceso de aprendizaje.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-5 d-flex justify-content-center px-5 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #FF004F;">
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #FF004F;">
                          Progreso mensurable
                        </span>
                        <span class="text-left">
                          Las evaluaciones periódicas y los análisis basados en datos permiten a los estudiantes 
                          hacer un seguimiento de su progreso y alcanzar sus objetivos de aprendizaje del idioma.
                        </span>
                      </div>
                    </div>
                </div>
                <div class=" mb-5 d-flex justify-content-center px-5 ">
                    <div class="d-flex justify-content-center px-2 py-4 rounded-4" style="border: 2px solid #116EEE;">
                      <div class="d-grid gap-2">
                        <span class="text-left fs-3 fw-bold" style="color: #116EEE;">
                          Entorno de apoyo
                        </span>
                        <span class="text-left">
                          Wediom brinda un entorno acogedor e inclusivo donde los estudiantes 
                          se sienten empoderados para asumir riesgos y mejorar continuamente.
                        </span>
                      </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center px-5">
                  <button mat-raised-button class="align-self-center w-100" (click)="formulario()" style="background-color: #1CA33A; color: #fff;">QUIERO REGISTRARME AL WEBINAR</button>
                </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-center p-5">
          <img  src="assets/img/sec_7.png" class="rounded-4 mx-5" height="800px"   style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
        </div>
      </div>
      <div class="row seccion_light">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid gap-2" style="padding: 5%;">
                <div class="fw-bold fs-2 d-flex justify-content-center mb-3 ">
                  <span class="text-center">
                    El Enfoque Estructurado
                  </span>
                </div>
                <div class=" fs-6 d-flex justify-content-center mb-3 ">
                  <span class="text-center">
                    Metodología paso apaso de Wediom
                  </span>
                </div>
                <div class="d-flex justify-content-center mb-3 gap-3">
                  <div class="rounded-4 seccion_light_4 d-grid  w-50 p-3">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-white" style="margin: 9% 40%; padding: 7% 0%;color: #0B4595;">
                        1
                      </span>
                      <span class="fw-bold fs-3 text-center mb-1">
                        Construcción de la base
                      </span>
                      <span class=" text-center" style="font-size: 12px;">
                        Establecer un dominio sólido de la gramática, el vocabulario y 
                        la pronunciación del inglés como base de la competencia lingüística.
                      </span>
                  </div>
                  <div class="rounded-4 seccion_light_4 d-grid  w-50 p-3">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-white" style="margin: 9% 40%; padding: 7% 0%;color: #0B4595;">
                        2
                      </span>
                      <span class="fw-bold fs-3 text-center mb-1">
                        Desarrollo de habilidades
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        Cultivar habilidades prácticas de comunicación en escucha, 
                        habla, lectura y escritura a través de ejercicios específicos.
                      </span>
                  </div>
                </div>
                <div class="d-flex justify-content-center mb-3 gap-3">
                  <div class="rounded-4 seccion_light_4 d-grid p-3 mx-2 gap-4 w-100 p-3">
                      <span class="fw-bold fs-1 text-center rounded-circle bg-white" style="margin: 2.5% 45%; padding: 4% 0%; color: #0B4595;">
                        3
                      </span>
                      <span class="fw-bold fs-3 text-center">
                        Aplicación en el mundo real
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        Establecer un dominio sólido de la gramática, el vocabulario y la pronunciación del inglés como base de la competencia lingüística.
                      </span>
                  </div>
                </div>
        </div>
      </div>
     <!--  <div class="row seccion_light_2">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid gap-2" style="padding: 5%;">
                <div class="fw-bold fs-2 d-flex justify-content-center mb-4 ">
                  <span class="text-center">
                    Aprende inglés y Cultura
                  </span>
                </div>
                <div class="d-flex justify-content-center mb-5 ">
                    <img src="../../../../assets/img/sec_8.png" width="750px" class="rounded-3">
                </div>
                <div class="d-flex justify-content-center mt-4 mb-3 gap-3 px-5">
                  <div class="d-grid">
                    <div class="fw-bold fs-2 d-flex justify-content-center mb-2 ">
                      <span class="text-center mb-3" style="color: #116EEE;">
                        Enfoque de
                        <br>
                        <br>
                        inmersión
                      </span>
                    </div>
                    <div class="fs-5 d-flex justify-content-center mb-4 ">
                      <span class="text-center">
                        El plan de estudios de Wediom te sumerge en elementos auténticos de la cultura estadounidense, 
                        lo que te ayuda a desarrollar habilidades lingüísticas en un contexto del mundo real.
                      </span>
                    </div>
                  </div>
                  <div class="d-grid">
                    <div class="fw-bold fs-2 d-flex justify-content-center mb-2 ">
                      <span class="text-center mb-3" style="color: #FF004F;">
                        Aprendizaje 
                        <br>
                        <br>
                        estructurado
                      </span>
                    </div>
                    <div class="fs-5 d-flex justify-content-center mb-4 ">
                      <span class="text-center">
                        El plan de estudios de Wediom te sumerge en elementos auténticos de la cultura estadounidense, 
                        lo que te ayuda a desarrollar habilidades lingüísticas en un contexto del mundo real.
                      </span>
                    </div>
                  </div>
                  <div class="d-grid">
                    <div class="fw-bold fs-2 d-flex justify-content-center mb-2 ">
                      <span class="text-center mb-3" style="color: #116EEE;">
                        Orientación 
                        <br>
                        <br>
                        personalizada
                      </span>
                    </div>
                    <div class="fs-5 d-flex justify-content-center mb-4 ">
                      <span class="text-center">
                        El plan de estudios de Wediom te sumerge en elementos auténticos de la cultura estadounidense, 
                        lo que te ayuda a desarrollar habilidades lingüísticas en un contexto del mundo real.
                      </span>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center px-5">
                  <button mat-raised-button class="align-self-center w-50" (click)="formulario()" style="background-color: #1CA33A; color: #fff;">QUIERO REGISTRARME AL WEBINAR</button>
                </div>
        </div>
      </div> -->
      <div class="row seccion_light">
        <div class="col-md-12 col-sm-12 col-xs-12 d-grid gap-2" style="padding: 10%;">
                <div class="fw-bold fs-2 d-flex justify-content-center mb-5 ">
                  <span class="text-center" >
                    Aprendizaje Progresivo y Estructurado
                  </span>
                </div>
                <div class="d-flex justify-content-center mb-3 gap-3 mx-5">
                  <div class="rounded-4  d-grid  w-25" style=" border: 1.5px solid #116EEE; opacity: 5;">
                      <img class="rounded-4" src="../../../../assets/img/sec_9.png" width="100%">
                  </div>
                  <div class="rounded-4 d-grid  w-75 p-4 bg-white" style=" border: 1.5px solid #116EEE; opacity: 5;">
                      <span class="fw-bold fs-3 text-center mb-1" style="color: #116EEE;">
                        Estructura o Columna vertebral
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        El plan de estudios de Wediom está diseñado con pasos incrementales para consolidar 
                        su dominio de la gramática, el vocabulario y las habilidades de comunicación en inglés.
                      </span>
                  </div>
                </div>
                <div class="d-flex justify-content-center mb-3 gap-3 mx-5">
                  <div class="rounded-4 d-grid  w-75 p-4 bg-white" style=" border: 1.5px solid #FFB207; opacity: 5;">
                      <span class="fw-bold fs-3 text-center mb-1" style="color: #FFB207;">
                        Estructura o Columna vertebral
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        El plan de estudios de Wediom está diseñado con pasos incrementales para consolidar 
                        su dominio de la gramática, el vocabulario y las habilidades de comunicación en inglés.
                      </span>
                  </div>
                  <div class="rounded-4  d-grid  w-25" style=" border: 1.5px solid #FFB207; opacity: 5;">
                    <img class="rounded-4" src="../../../../assets/img/sec_10.png" width="100%">
                  </div>
                </div>
                <div class="d-flex justify-content-center mb-3 gap-3 mx-5">
                  <div class="rounded-4  d-grid  w-25" style=" border: 1.5px solid #116EEE; opacity: 5;">
                    <img class="rounded-4" src="../../../../assets/img/sec_11.png" width="100%">
                  </div>
                  <div class="rounded-4 d-grid  w-75 p-4 bg-white" style=" border: 1.5px solid #116EEE; opacity: 5;">
                      <span class="fw-bold fs-3 text-center mb-1" style="color: #116EEE;">
                        Mejora Continua
                      </span>
                      <span class="text-center" style="font-size: 12px;">
                        Las evaluaciones regulares y la retroalimentación personalizada aseguran que
                         esté haciendo un progreso constante y logrando sus objetivos de aprendizaje de idiomas.
                      </span>
                  </div>
                </div>
        </div>
      </div>

      <!-- final -->
      <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12 d-grid  py-5 px-3 mt-5">
                <div class="fw-bold fs-1  text-center mb-3">
                  <span class="">
                    ¡Reserva tu lugar ahora!
                  </span>
                </div>
                <div class="px-auto">
                  <hr class="col-4 rounded mx-auto" style="background-color: #50E170; border: 0.5px solid #50E170; opacity: 5;">
                </div>
                <div class=" fs-5 text-center">
                  <span class=" ">
                    Completa el formulario y Aprende estrategias clave y 
                    recibe consejos de expertos del Idioma Inglés en nuestro webinar exclusivo para ti.
                  </span>
                </div>
                <div class="d-flex justify-content-center mt-5">
                    <div class="col-9 mat-elevation-z8 p-3 rounded ml-4" style="background-color: #FFFFFF;">
                        <form id="forma" [formGroup]="forma" (ngSubmit)="modalrespuesta()" >
                            <div class="row pb-2">
                                <div class="col-12 d-flex justify-content-center">
                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                        <mat-label>Nombre y Apellido </mat-label>
                                        <input type="text" matInput    autocomplete="off" formControlName="des_usuario" style="color: #000;">
                                        <span mat-icon-button matSuffix >
                                            <mat-icon >account_circle</mat-icon>
                                         </span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row pb-2">
                                <div class="col-12 d-flex justify-content-center">
                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                        <mat-label>Teléfono</mat-label>
                                        <input type="text" matInput    autocomplete="off" formControlName="tel_usuario" style="color: #000;">
                                        <span mat-icon-button matSuffix >
                                            <mat-icon >account_circle</mat-icon>
                                         </span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row pb-2">
                                <div class="col-12 d-flex justify-content-center">
                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                        <mat-label>Correo Electrónico</mat-label>
                                        <input type="text" matInput    autocomplete="off" formControlName="mail_usuario" style="color: #000;">
                                        <span mat-icon-button matSuffix >
                                            <mat-icon >account_circle</mat-icon>
                                         </span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row pb-2">
                                <div class="col-12 d-flex justify-content-center">
                                    <button class="col-12 mb-2" mat-raised-button type="submit"  [disabled]="forma.invalid" style="background-color: #1CA33A; color: #fff;"> ENVIAR</button>
                                </div>  
                            </div>
                        </form>
                    </div>
                </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-start p-0">
            <img  src="assets/img/sec_1.png"   style=" aspect-ratio: 1/1;  width:100%; object-fit: 100% 100%;">
        </div>
      </div>
    </div> 
</div>
<app-footer></app-footer>
